import { hashQuery, query } from '../query';
const fullParamsKey = [
    /* 页面信息 */
    'xbiz',
    'prod_key',
    'xpsid',
    'dchn',
    // 'xspm',
    'xoid',
    /* 用户信息 */
    /* 环境信息 */
    'xenv',
    /* 路径信息 */
    'xspm_from',
    'xpsid_root',
    'xpsid_from',
    'xpsid_share',
    'xpos_from'
];
/**
 * getNineChapterParams: 通过url参数获取九章参数
 * @param url
 * @example
 * ```js
 *  const parameters = getNineChapterParams(url)
 * ```
 */
const getNineChapterParams = (url) => {
    const collection = Object.assign({}, query(url), hashQuery(url));
    return fullParamsKey.reduce((result, key) => {
        if (collection[key]) {
            result[key] = collection[key];
        }
        else if (key !== 'xpos_from') {
            result[key] = '';
        }
        return result;
    }, {});
};
export { getNineChapterParams };
